var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTransmissionPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 148,
    viewBox: "0 0 162 148",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 6C86 2.68629 88.6863 0 92 0H138C141.314 0 144 2.68629 144 6V48C144 51.3137 141.314 54 138 54H92C88.6863 54 86 51.3137 86 48V6Z",
    fill: "#1E273B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 81C0 77.6863 2.68629 75 6 75H42C45.3137 75 48 77.6863 48 81V115C48 118.314 45.3137 121 42 121H6C2.68629 121 0 118.314 0 115V81Z",
    fill: "#FC7292"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 88.125H31.3487L28.375 84.875H18.625L15.6513 88.125H10.5C8.7125 88.125 7.25 89.5875 7.25 91.375V110.875C7.25 112.663 8.7125 114.125 10.5 114.125H36.5C38.2875 114.125 39.75 112.663 39.75 110.875V91.375C39.75 89.5875 38.2875 88.125 36.5 88.125ZM36.5 110.875H10.5V91.375H17.0813L20.055 88.125H26.945L29.9187 91.375H36.5V110.875Z",
    fill: "#E45A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2812 106L18.625 101.125L13.75 107.625H33.25L27.1562 99.5L22.2812 106Z",
    fill: "#E45A7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 15.125H123.349L120.375 11.875H110.625L107.651 15.125H102.5C100.712 15.125 99.25 16.5875 99.25 18.375V37.875C99.25 39.6625 100.712 41.125 102.5 41.125H128.5C130.288 41.125 131.75 39.6625 131.75 37.875V18.375C131.75 16.5875 130.288 15.125 128.5 15.125ZM128.5 37.875H102.5V18.375H109.081L112.055 15.125H118.945L121.919 18.375H128.5V37.875Z",
    fill: "#2D374F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.281 33L110.625 28.125L105.75 34.625H125.25L119.156 26.5L114.281 33Z",
    fill: "#2D374F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.3047,
    y: 8.5,
    width: 81.0283,
    height: 138.704,
    rx: 8.5,
    fill: "black",
    fillOpacity: 0.22,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8047,
    y: 112,
    width: 75.1985,
    height: 14.3858,
    rx: 2,
    fill: "#EAEAEA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89.0742,
    y: 113.962,
    width: 11.7702,
    height: 10.4624,
    rx: 2,
    fill: "#00C6C6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102.806,
    y: 117.885,
    width: 26.156,
    height: 1.3078,
    rx: 0.6539,
    fill: "#807376"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 102.806,
    y: 119.847,
    width: 39.234,
    height: 1.3078,
    rx: 0.6539,
    fill: "#1E273B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8047,
    y: 89,
    width: 62.1205,
    height: 14.3858,
    rx: 2,
    fill: "#EAEAEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 89.0742,
    y: 90.9617,
    width: 11.7702,
    height: 10.4624,
    rx: 2,
    fill: "#00C6C6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 102.807,
    y: 94.8851,
    width: 26.156,
    height: 1.3078,
    rx: 0.6539,
    fill: "#807376"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 102.807,
    y: 96.8468,
    width: 39.234,
    height: 1.3078,
    rx: 0.6539,
    fill: "#1E273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransmissionPhoto);
export default __webpack_public_path__ + "static/media/no-transmission-photo.04bd8432876d80d16b97d9c35c905e34.svg";
export { ForwardRef as ReactComponent };